import { render, staticRenderFns } from "./orgindex.vue?vue&type=template&id=f9f720ea&scoped=true&"
import script from "./orgindex.vue?vue&type=script&lang=js&"
export * from "./orgindex.vue?vue&type=script&lang=js&"
import style0 from "./orgindex.vue?vue&type=style&index=0&id=f9f720ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f720ea",
  null
  
)

export default component.exports